// src/components/BotonAgregar.js
import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const BotonAgregar = ({ onClick, title = "Agregar", icon = <AddIcon sx={{ fontSize: 'clamp(15px, 1.2vw, 18px)' }} />, disabled = false }) => {
  return (
    <Tooltip title={title} arrow>
      <span>
        <IconButton
          onClick={onClick}
          disabled={disabled}
          sx={{
            backgroundColor: '#43a047',
            color: 'white',
            borderRadius: '50%',
            width: 'clamp(26px, 2.2vw, 32px)',
            height: 'clamp(26px, 2.2vw, 32px)',
            '&:hover': { backgroundColor: '#2e7d32' },
            '&.Mui-disabled': { backgroundColor: '#9e9e9e', color: '#ffffff' },
          }}
        >
          {icon}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default BotonAgregar;